import { downloadFileWithCustomName } from "utils/download/download.utils";
import {
  QR_PAYMENT_TYPES,
  QR_PAYMENT_TYPE_KEYS,
  QR_FLOW_PARAMS,
  QR_FILE_CONSTANTS,
  getQrImageUrl,
  QR_MODAL_NUMBERS,
} from "./QrModal.constants";

export const getTargetUrl = (displayUrl, selectedType) => {
  if (!displayUrl) return "";
  if (
    selectedType === QR_PAYMENT_TYPES.INSTANT_DELIVERY_QR ||
    selectedType === QR_PAYMENT_TYPE_KEYS.UPI
  ) {
    const separator = displayUrl.includes("?") ? "&" : "?";
    return `${displayUrl}${separator}${QR_FLOW_PARAMS.UPI_PARAM}`;
  }
  return displayUrl;
};

export const handleQrDownload = (
  displayUrl,
  selectedType,
  recordTitle,
  isDirectImageUrl = false
) => {
  const targetUrl = getTargetUrl(displayUrl, selectedType);
  const qrImageUrl = isDirectImageUrl
    ? displayUrl
    : getQrImageUrl(targetUrl, QR_MODAL_NUMBERS.QR_CODE_SIZE);

  if (!qrImageUrl) return;

  const isInstantUpi =
    selectedType === QR_PAYMENT_TYPES.INSTANT_DELIVERY_QR ||
    selectedType === QR_PAYMENT_TYPE_KEYS.UPI;

  const prefix = recordTitle
    ? recordTitle.toLowerCase().replace(QR_FILE_CONSTANTS.FILENAME_REGEX, "-")
    : QR_FILE_CONSTANTS.DEFAULT_NAME;

  const fileName = `${prefix}-${isInstantUpi}-${QR_FILE_CONSTANTS.SUFFIX_QR}`;
  downloadFileWithCustomName(
    qrImageUrl,
    fileName,
    QR_MODAL_NUMBERS.QR_CODE_DOWNLOAD_SIZE
  );
};
